import { endpoints } from "./Config";

const baseURL = endpoints.baseURL;
export const LOGIN = `${baseURL}${endpoints.auth.Login}`;
export const FORGOTPASSWORD = `${baseURL}${endpoints.auth.ForgotPassword}`;
export const CHANGEPASSWORD = `${baseURL}${endpoints.auth.ChangePassWord}`;
export const RESETPASSWORD = `${baseURL}${endpoints.auth.ResetPassword}`;
//Products
export const GETALLPRODUCTS = `${baseURL}${endpoints.products.GETALLPRODUCTS}`;
export const ADDNEWPRODUCT = `${baseURL}${endpoints.products.ADDNEWPRODUCT}`;
export const DELETEPRODUCT = `${baseURL}${endpoints.products.DELETEPRODUCT}`;
export const UPDATEPRODUCT = `${baseURL}${endpoints.products.UPDATEPRODUCT}`;
export const GETPRODUCTURL = `${baseURL}${endpoints.products.GETPRODUCTURL}`;
export const UPDATEPASTORDERPRODUCT = `${baseURL}${endpoints.products.UPDATEPASTORDERPRODUCT}`;
export const ALLOWREFUND = `${baseURL}${endpoints.products.ALLOWREFUND}`;
export const DECLINEREFUND = `${baseURL}${endpoints.products.DECLINEREFUND}`;
//Orders
export const GETNEWORDERS = `${baseURL}${endpoints.orders.GETNEWORDERS}`;
export const GETNEWORDERS_V2 = `${baseURL}${endpoints.orders.GETNEWORDERS_V2}`;
export const UPDATEORDERSTATUS = `${baseURL}${endpoints.orders.UPDATEORDERSTATUS}`;
export const AcceptOrder = `${baseURL}${endpoints.orders.AcceptOrder}`;
export const UPDATENEWORDERFLAG = `${baseURL}${endpoints.orders.UPDATENEWORDERFLAG}`;
export const GETORDERLISTWITHSTATUS = `${baseURL}${endpoints.orders.GETORDERLISTWITHSTATUS}`;
export const GETORDERLISTWITHSTATUS_V2 = `${baseURL}${endpoints.orders.GETORDERLISTWITHSTATUS_V2}`;
export const REPORTORDERISSUE = `${baseURL}${endpoints.orders.REPORTORDERISSUE}`;
export const SHIPORDER = `${baseURL}${endpoints.orders.SHIPORDER}`;
export const SHIPMEMORABILIAORDER = `${baseURL}${endpoints.orders.SHIPMEMORABILIAORDER}`;
export const SHIPMEMORABILIAORDERTOCUSTOMER = `${baseURL}${endpoints.orders.SHIPMEMORABILIAORDERTOCUSTOMER}`;
export const SHIPORDERCANCEL = `${baseURL}${endpoints.orders.SHIPORDERCANCEL}`;
export const REQUESTFEDEXPICKUP = `${baseURL}${endpoints.orders.REQUESTFEDEXPICKUP}`;
export const REQUESTMEMORABILIAFEDEXPICKUP = `${baseURL}${endpoints.orders.REQUESTMEMORABILIAFEDEXPICKUP}`;
export const GETSERVICELABELS = `${baseURL}${endpoints.orders.GETSERVICELABELS}`;
export const CONFIRMSERVICELABELPRINT = `${baseURL}${endpoints.orders.CONFIRMSERVICELABELPRINT}`;

export const GETUSERS = `${baseURL}${endpoints.admin.GETUSERS}`;
export const VIEWASUSER = `${baseURL}${endpoints.admin.VIEWASUSER}`;
